import React, { Dispatch, SetStateAction } from 'react';
import { useSelector } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';
import InputLabel from '@material-ui/core/InputLabel';
import { makeStyles, Theme } from '@material-ui/core/styles';
// import Help from '../../../../help/components/help.component';
import appConfig from '../../../../../application/app.config';
import { selectTemplateById } from '../../../template.selector';
import { selectInfos } from '../../../../info/info.selector';
import { updateTemplateWithInfos } from '../../../helpers/textFormat.helpers';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1),
    flex: 1,
  },
  label: {
    paddingLeft: theme.spacing(0.5),
    marginTop: theme.spacing(2),
  },
  fieldInfo: {
    display: 'flex',
    justifyContent: 'space-between',
    color: theme.palette.text.secondary,
  },
  help: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(3),
  },
}));

export interface IProps {
  selectedTemplateId: string;
  setSelectedTemplateId: Dispatch<SetStateAction<string>>;
  content: string;
  setContent: Dispatch<SetStateAction<string>>;
  setIsStepValid: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function TemplateUpdate(props: IProps) {
  const {
    content,
    setContent,
    selectedTemplateId,
    setSelectedTemplateId,
    setIsStepValid,
  } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  const infos = useSelector(selectInfos);
  const template = useSelector(selectTemplateById)(selectedTemplateId);

  /**
   * Valid step
   */
  React.useEffect(() => {
    if (content.length > 0) {
      setIsStepValid(true);
    } else {
      setIsStepValid(false);
    }
  }, [content, setIsStepValid]);

  /**
   * Update template with standards user infos
   */
  React.useEffect(() => {
    if (template && infos) {
      const templateUpdatedWithInfos = updateTemplateWithInfos(template, infos);
      setContent(templateUpdatedWithInfos);
      setSelectedTemplateId('');
    }
  });

  function handleOnChange(event: React.ChangeEvent<HTMLInputElement>) {
    const text = event.target.value;
    if (text.length <= appConfig.templateMaxLength) {
      setContent(text);
      setSelectedTemplateId('');
    }
  }

  return (
    <div id="template-create" className={classes.container}>
      <InputLabel htmlFor="lastName" className={classes.label}>
        {t('message.text.create.label')}
      </InputLabel>
      <TextField
        id="content"
        multiline
        rows="3"
        name="content"
        autoFocus
        variant="outlined"
        margin="normal"
        type="text"
        value={content}
        placeholder={'Rédigez votre annonce'}
        onChange={handleOnChange}
        color="secondary"
      />
      <div id="field-info" className={classes.fieldInfo}>
        <Typography>{t('message.text.create.maxChar')}</Typography>
        <Typography>{`${content.length}/${appConfig.templateMaxLength}`}</Typography>
      </div>

      {/* <div className={classes.help}>
        <Help />
      </div> */}
    </div>
  );
}
